import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SecondFactorVerificationFailedAction = {
	type: 'SECOND_FACTOR_VERIFICATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SecondFactorVerificationFailedAction => ({
	type: 'SECOND_FACTOR_VERIFICATION_FAILED',
	payload,
});
